var _g, _g2, _g3, _g4, _g5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDrawActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 60,
    viewBox: "0 0 110 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_3232_25480)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 17,
    width: 18,
    height: 24.6,
    rx: 1.75714,
    fill: "#A046D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4384 24.4934V23.7146L19.4316 21.9458C19.5812 21.8138 19.6868 21.6895 19.7484 21.5729C19.81 21.4563 19.8408 21.3474 19.8408 21.2462C19.8408 21.101 19.8111 20.9723 19.7517 20.8601C19.6923 20.7457 19.6087 20.6566 19.5009 20.5928C19.3931 20.5268 19.2666 20.4938 19.1214 20.4938C18.9696 20.4938 18.8354 20.529 18.7188 20.5994C18.6044 20.6676 18.5153 20.7589 18.4515 20.8733C18.3877 20.9855 18.358 21.1076 18.3624 21.2396H17.4384C17.4384 20.914 17.5099 20.6324 17.6529 20.3948C17.7959 20.1572 17.995 19.9735 18.2502 19.8437C18.5054 19.7139 18.8024 19.649 19.1412 19.649C19.4514 19.649 19.7286 19.7172 19.9728 19.8536C20.2192 19.9878 20.4128 20.1759 20.5536 20.4179C20.6944 20.6599 20.7648 20.9404 20.7648 21.2594C20.7648 21.4948 20.7318 21.6906 20.6658 21.8468C20.5998 22.0008 20.5019 22.1438 20.3721 22.2758C20.2423 22.4056 20.0828 22.553 19.8936 22.718L18.6066 23.8466L18.534 23.6486H20.7648V24.4934H17.4384Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3232_25480)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.35 28.9191C21.35 27.7628 19.6794 27.166 19.1156 26.0936L19.0948 26.075L19.0843 26.0936C18.5205 27.166 16.85 27.7628 16.85 28.9191C16.85 29.8889 18.2804 30.2619 18.9799 29.4506C18.9903 29.4133 18.9799 29.7117 18.9277 29.8796C18.7606 30.3738 18.1551 31.1012 17.8627 31.325C18.2699 31.0172 19.9091 31.0172 20.3163 31.325C20.024 31.1012 19.4497 30.4018 19.2514 29.8796C19.2096 29.7304 19.1887 29.5905 19.1783 29.4413C19.8674 30.3178 21.35 29.9075 21.35 28.9191Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M29.1499 35.4944C29.1499 33.4131 26.143 32.3389 25.1281 30.4086L25.0905 30.375L25.0717 30.4086C24.0569 32.3389 21.0499 33.4131 21.0499 35.4944C21.0499 37.2401 23.6246 37.9115 24.8838 36.4512C24.9026 36.3841 24.8838 36.9212 24.7898 37.2233C24.4891 38.1129 23.3991 39.4222 22.8729 39.825C23.6058 39.2711 26.5564 39.2711 27.2894 39.825C26.7632 39.4222 25.7295 38.1633 25.3724 37.2233C25.2973 36.9548 25.2597 36.703 25.2409 36.4344C26.4812 38.0122 29.1499 37.2737 29.1499 35.4944Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_dd_3232_25480)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 17,
    width: 18,
    height: 24.6,
    rx: 1.75714,
    fill: "#A046D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9983 24.5858C34.7607 24.5858 34.5341 24.5385 34.3185 24.4439C34.1029 24.3471 33.9148 24.2118 33.7542 24.038C33.5958 23.8642 33.4825 23.6596 33.4143 23.4242L34.2855 23.1932C34.3317 23.367 34.4219 23.5023 34.5561 23.5991C34.6925 23.6937 34.8399 23.741 34.9983 23.741C35.1347 23.741 35.259 23.708 35.3712 23.642C35.4856 23.576 35.5758 23.4869 35.6418 23.3747C35.71 23.2625 35.7441 23.1382 35.7441 23.0018C35.7441 22.7972 35.6737 22.6223 35.5329 22.4771C35.3943 22.3297 35.2161 22.256 34.9983 22.256C34.9323 22.256 34.8685 22.2659 34.8069 22.2857C34.7453 22.3033 34.6859 22.3286 34.6287 22.3616L34.2261 21.6554L35.7375 20.4014L35.8035 20.5928H33.5991V19.748H36.5691V20.5928L35.3943 21.728L35.3877 21.4772C35.6605 21.519 35.8904 21.6147 36.0774 21.7643C36.2666 21.9117 36.4096 22.0943 36.5064 22.3121C36.6054 22.5277 36.6549 22.7576 36.6549 23.0018C36.6549 23.301 36.579 23.5705 36.4272 23.8103C36.2754 24.0479 36.0741 24.2371 35.8233 24.3779C35.5725 24.5165 35.2975 24.5858 34.9983 24.5858Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3232_25480)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.35 28.9191C37.35 27.7628 35.6794 27.166 35.1156 26.0936L35.0948 26.075L35.0843 26.0936C34.5205 27.166 32.85 27.7628 32.85 28.9191C32.85 29.8889 34.2804 30.2619 34.9799 29.4506C34.9903 29.4133 34.9799 29.7117 34.9277 29.8796C34.7606 30.3738 34.1551 31.1012 33.8627 31.325C34.2699 31.0172 35.9091 31.0172 36.3163 31.325C36.024 31.1012 35.4497 30.4018 35.2514 29.8796C35.2096 29.7304 35.1887 29.5905 35.1783 29.4413C35.8674 30.3178 37.35 29.9075 37.35 28.9191Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M45.1499 35.4944C45.1499 33.4131 42.143 32.3389 41.1281 30.4086L41.0905 30.375L41.0717 30.4086C40.0569 32.3389 37.0499 33.4131 37.0499 35.4944C37.0499 37.2401 39.6246 37.9115 40.8838 36.4512C40.9026 36.3841 40.8838 36.9212 40.7898 37.2233C40.4891 38.1129 39.3991 39.4222 38.8729 39.825C39.6058 39.2711 42.5564 39.2711 43.2894 39.825C42.7632 39.4222 41.7295 38.1633 41.3724 37.2233C41.2973 36.9548 41.2597 36.703 41.2409 36.4344C42.4812 38.0122 45.1499 37.2737 45.1499 35.4944Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_dd_3232_25480)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 17,
    width: 18,
    height: 24.6,
    rx: 1.75714,
    fill: "#A046D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.4655 24.5V23.7608H49.3997V22.9226L50.8979 19.748H51.9275L50.4293 22.9226H51.4655V21.7346H52.3763V22.9226H52.7987V23.7608H52.3763V24.5H51.4655Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_3232_25480)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.35 28.9191C53.35 27.7628 51.6794 27.166 51.1156 26.0936L51.0948 26.075L51.0843 26.0936C50.5205 27.166 48.85 27.7628 48.85 28.9191C48.85 29.8889 50.2804 30.2619 50.9799 29.4506C50.9903 29.4133 50.9799 29.7117 50.9277 29.8796C50.7606 30.3738 50.1551 31.1012 49.8627 31.325C50.2699 31.0172 51.9091 31.0172 52.3163 31.325C52.024 31.1012 51.4497 30.4018 51.2514 29.8796C51.2096 29.7304 51.1887 29.5905 51.1783 29.4413C51.8674 30.3178 53.35 29.9075 53.35 28.9191Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M61.1499 35.4944C61.1499 33.4131 58.143 32.3389 57.1281 30.4086L57.0905 30.375L57.0717 30.4086C56.0569 32.3389 53.0499 33.4131 53.0499 35.4944C53.0499 37.2401 55.6246 37.9115 56.8838 36.4512C56.9026 36.3841 56.8838 36.9212 56.7898 37.2233C56.4891 38.1129 55.3991 39.4222 54.8729 39.825C55.6058 39.2711 58.5564 39.2711 59.2894 39.825C58.7632 39.4222 57.7295 38.1633 57.3724 37.2233C57.2973 36.9548 57.2597 36.703 57.2409 36.4344C58.4812 38.0122 61.1499 37.2737 61.1499 35.4944Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_dd_3232_25480)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 17,
    width: 18,
    height: 24.6,
    rx: 1.75714,
    fill: "#A046D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.0311 24.599C66.7913 24.599 66.5658 24.5495 66.3546 24.4505C66.1456 24.3515 65.9652 24.214 65.8134 24.038C65.6616 23.862 65.5527 23.6574 65.4867 23.4242L66.3513 23.1932C66.3799 23.3054 66.4305 23.4022 66.5031 23.4836C66.5779 23.565 66.6637 23.6288 66.7605 23.675C66.8595 23.719 66.9607 23.741 67.0641 23.741C67.2005 23.741 67.3248 23.708 67.437 23.642C67.5514 23.576 67.6416 23.4869 67.7076 23.3747C67.7758 23.2625 67.8099 23.1382 67.8099 23.0018C67.8099 22.8654 67.7758 22.7411 67.7076 22.6289C67.6416 22.5167 67.5514 22.4276 67.437 22.3616C67.3248 22.2956 67.2005 22.2626 67.0641 22.2626C66.8969 22.2626 66.7605 22.2912 66.6549 22.3484C66.5493 22.4034 66.4701 22.4562 66.4173 22.5068L65.6583 22.2758L65.8035 19.748H68.3973V20.5862H66.2985L66.6153 20.2892L66.5163 21.9194L66.3645 21.7346C66.4833 21.6378 66.6186 21.5674 66.7704 21.5234C66.9222 21.4794 67.0641 21.4574 67.1961 21.4574C67.4953 21.4574 67.7582 21.5245 67.9848 21.6587C68.2136 21.7907 68.3918 21.9733 68.5194 22.2065C68.6492 22.4375 68.7141 22.7026 68.7141 23.0018C68.7141 23.301 68.636 23.5716 68.4798 23.8136C68.3236 24.0534 68.1179 24.2448 67.8627 24.3878C67.6075 24.5286 67.3303 24.599 67.0311 24.599Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_3232_25480)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.35 28.9191C69.35 27.7628 67.6794 27.166 67.1156 26.0936L67.0948 26.075L67.0843 26.0936C66.5205 27.166 64.85 27.7628 64.85 28.9191C64.85 29.8889 66.2804 30.2619 66.9799 29.4506C66.9903 29.4133 66.9799 29.7117 66.9277 29.8796C66.7606 30.3738 66.1551 31.1012 65.8627 31.325C66.2699 31.0172 67.9091 31.0172 68.3163 31.325C68.024 31.1012 67.4497 30.4018 67.2514 29.8796C67.2096 29.7304 67.1887 29.5905 67.1783 29.4413C67.8674 30.3178 69.35 29.9075 69.35 28.9191Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M77.1499 35.4944C77.1499 33.4131 74.143 32.3389 73.1281 30.4086L73.0905 30.375L73.0717 30.4086C72.0569 32.3389 69.0499 33.4131 69.0499 35.4944C69.0499 37.2401 71.6246 37.9115 72.8838 36.4512C72.9026 36.3841 72.8838 36.9212 72.7898 37.2233C72.4891 38.1129 71.3991 39.4222 70.8729 39.825C71.6058 39.2711 74.5564 39.2711 75.2894 39.825C74.7632 39.4222 73.7295 38.1633 73.3724 37.2233C73.2973 36.9548 73.2597 36.703 73.2409 36.4344C74.4812 38.0122 77.1499 37.2737 77.1499 35.4944Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_dd_3232_25480)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 78,
    y: 17,
    width: 18,
    height: 24.6,
    rx: 1.75714,
    fill: "#A046D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.0046 24.5L83.6018 20.5928H81.569V19.748H84.5654V20.5928L82.9748 24.5H82.0046Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_3232_25480)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.35 28.9191C85.35 27.7628 83.6794 27.166 83.1156 26.0936L83.0948 26.075L83.0843 26.0936C82.5205 27.166 80.85 27.7628 80.85 28.9191C80.85 29.8889 82.2804 30.2619 82.9799 29.4506C82.9903 29.4133 82.9799 29.7117 82.9277 29.8796C82.7606 30.3738 82.1551 31.1012 81.8627 31.325C82.2699 31.0172 83.9091 31.0172 84.3163 31.325C84.024 31.1012 83.4497 30.4018 83.2514 29.8796C83.2096 29.7304 83.1887 29.5905 83.1783 29.4413C83.8674 30.3178 85.35 29.9075 85.35 28.9191Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M93.1499 35.4944C93.1499 33.4131 90.143 32.3389 89.1281 30.4086L89.0905 30.375L89.0717 30.4086C88.0569 32.3389 85.0499 33.4131 85.0499 35.4944C85.0499 37.2401 87.6246 37.9115 88.8838 36.4512C88.9026 36.3841 88.8838 36.9212 88.7898 37.2233C88.4891 38.1129 87.3991 39.4222 86.8729 39.825C87.6058 39.2711 90.5564 39.2711 91.2894 39.825C90.7632 39.4222 89.7295 38.1633 89.3724 37.2233C89.2973 36.9548 89.2597 36.703 89.2409 36.4344C90.4812 38.0122 93.1499 37.2737 93.1499 35.4944Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_3232_25480",
    x: 0,
    y: 7,
    width: 46,
    height: 52.6001,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3232_25480"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.627451 0 0 0 0 0.282353 0 0 0 0 0.827451 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_3232_25480",
    result: "effect2_dropShadow_3232_25480"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_3232_25480",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_dd_3232_25480",
    x: 16,
    y: 7,
    width: 46,
    height: 52.6001,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3232_25480"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.627451 0 0 0 0 0.282353 0 0 0 0 0.827451 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_3232_25480",
    result: "effect2_dropShadow_3232_25480"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_3232_25480",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_dd_3232_25480",
    x: 32,
    y: 7,
    width: 46,
    height: 52.6001,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3232_25480"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.627451 0 0 0 0 0.282353 0 0 0 0 0.827451 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_3232_25480",
    result: "effect2_dropShadow_3232_25480"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_3232_25480",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_dd_3232_25480",
    x: 48,
    y: 7,
    width: 46,
    height: 52.6001,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3232_25480"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.627451 0 0 0 0 0.282353 0 0 0 0 0.827451 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_3232_25480",
    result: "effect2_dropShadow_3232_25480"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_3232_25480",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_dd_3232_25480",
    x: 64,
    y: 7,
    width: 46,
    height: 52.6001,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3232_25480"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.627451 0 0 0 0 0.282353 0 0 0 0 0.827451 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_3232_25480",
    result: "effect2_dropShadow_3232_25480"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_3232_25480",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3232_25480"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6,
    fill: "white",
    transform: "translate(16.1 25.7)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3232_25480"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6,
    fill: "white",
    transform: "translate(32.1 25.7)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_3232_25480"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6,
    fill: "white",
    transform: "translate(48.1 25.7)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_3232_25480"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6,
    fill: "white",
    transform: "translate(64.1 25.7)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_3232_25480"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6,
    fill: "white",
    transform: "translate(80.1 25.7)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrawActive);
export default __webpack_public_path__ + "static/media/draw-active.b0eec1129d34cb2f5e7ca9e084a1c29d.svg";
export { ForwardRef as ReactComponent };